import { useEffect, useState } from 'react';
import useVideoContext from '../useVideoContext/useVideoContext';
export default function useParticipants() {
    const { room } = useVideoContext();
    const participantsIntialValue = room.participants && room.participants.size > 0 ? Array.from(room.participants.values()) : [];
    const [participants, setParticipants] = useState(participantsIntialValue);
    useEffect(() => {
        const participantConnected = (participant) => setParticipants(prevParticipants => [...prevParticipants, participant]);
        const participantDisconnected = (participant) => setParticipants(prevParticipants => prevParticipants.filter(p => p !== participant));
        room.on('participantConnected', participantConnected);
        room.on('participantDisconnected', participantDisconnected);
        return () => {
            room.off('participantConnected', participantConnected);
            room.off('participantDisconnected', participantDisconnected);
        };
    }, [room]);
    return participants;
}
//# sourceMappingURL=useParticipants.js.map